import type { ArithKey } from './keys';

export const ro: Partial<Record<ArithKey, string>> = {
  'app.title': 'Aritmetică',
  'app.eyebrow': 'Matematică · Aritmetică',
  'app.tagline': 'Calcul vizual pe tot programul de aritmetică de liceu',
  'app.panel.heading': 'Parametri',
  'panel.enter-number': 'Introdu un număr',
  'formula.is-prime': 'este prim',
  'experiment.fraction-foundry.label': 'Fabrica de fracții',
  'experiment.percent-grid.label': 'Grilă procentuală',
  'experiment.prime-factor-tree.label': 'Arbore de factori primi',
  'experiment.modular-clock.label': 'Ceas modular',
  'experiment.number-line-surgeon.label': 'Chirurg pe axa numerelor',
  'experiment.place-value-blocks.label': 'Blocuri de poziție',
  'experiment.ratio-mixer.label': 'Mixer de rapoarte',
  'experiment.power-tower.label': 'Turn de puteri',
  'op.add': 'plus',
  'op.sub': 'minus',
  'op.mul': 'ori',
  'op.div': 'împărțit la',
  'btn.reset': 'Reinițializează',
  'btn.randomise': 'Aleatoriu',
  'btn.advanced': 'Avansat',
  'class.perfect': 'număr perfect',
  'class.abundant': 'număr abundent',
  'class.deficient': 'număr deficient',
  'mode.basic': 'De bază',
  'mode.inverse': 'Invers',
};
